module.exports = __webpack_public_path__ + "img/40_00_000_813.a3d8810f.jpg";